import axios from '@src/utils/axios'

const module = 'exam'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },
  'all': () => axiosInstance.get(`/${module}`),
  'getApplicantExams': () => axiosInstance.get(`/${module}/get-applicant-exams`),
  'takeExam': (ctx, data) => {
    return axiosInstance.put(`/${module}/take-exam/` + data.application_exam)
  },
  'submitExam': (ctx, data) => {
    return axiosInstance.put(`/${module}/submit-exam/` + data.applicationExamId, { params: data })
  },
  'getManualGrading': () => axiosInstance.get(`/${module}/find-exams-needing-manual-grading`),
  'getExamsWithManualGrading': (ctx, data) => {
    return axiosInstance.get(`/${module}/get-exams-needing-manual-grading`, { params: data })
  },
  'updateApplicantScores': (ctx, data) => {
    return axiosInstance.put(`/${module}/update-applicant-scores`, data)
  }
}